import { useMemo, useState, useCallback } from 'react';
import { getNaverAppUrl, getPayAppUrl } from '@financial/app-js-interfaces';
import { TIMEOUT } from '../../share/constants.mjs';

const useUrl = _ref => {
  let {
    phase,
    env,
    shouldInAppBrowserOpen,
    landingUrl,
    serviceMenuOption
  } = _ref;
  const targetUrl = useMemo(() => ({
    NAVER_APP_ANDROID: getNaverAppUrl({
      landingUrl,
      deviceType: 'android',
      from: 'qr'
    }),
    NAVER_APP_IOS: getNaverAppUrl({
      landingUrl,
      deviceType: 'ios'
    }),
    PAY_APP_ANDROID: getPayAppUrl({
      phase,
      deviceType: 'android',
      ...(shouldInAppBrowserOpen ? {
        shouldInAppBrowserOpen,
        landingUrl
      } : {
        shouldInAppBrowserOpen,
        serviceMenuOption
      })
    }),
    PAY_APP_IOS: getPayAppUrl({
      phase,
      deviceType: 'ios',
      ...(shouldInAppBrowserOpen ? {
        shouldInAppBrowserOpen,
        landingUrl
      } : {
        shouldInAppBrowserOpen,
        serviceMenuOption
      })
    })
  }), [landingUrl, phase, serviceMenuOption, shouldInAppBrowserOpen]);
  const [shortenUrl, setShortenUrl] = useState({
    NAVER_APP_ANDROID: '',
    NAVER_APP_IOS: '',
    PAY_APP_ANDROID: '',
    PAY_APP_IOS: ''
  });
  const [showRetry, setShowRetry] = useState({
    NAVER_APP_ANDROID: false,
    NAVER_APP_IOS: false,
    PAY_APP_ANDROID: false,
    PAY_APP_IOS: false
  });
  const resetShortenUrl = useCallback(() => setShortenUrl({
    NAVER_APP_ANDROID: '',
    NAVER_APP_IOS: '',
    PAY_APP_ANDROID: '',
    PAY_APP_IOS: ''
  }), []);
  const expireShortenUrl = useCallback(() => {
    setTimeout(() => {
      setShowRetry(prev => ({
        ...prev,
        [env]: true
      }));
    }, TIMEOUT);
  }, [env]);
  const renewShortenUrl = useCallback(() => setShowRetry(prev => ({
    ...prev,
    [env]: false
  })), [env]);
  return useMemo(() => ({
    targetUrl,
    shortenUrl,
    setShortenUrl,
    resetShortenUrl,
    expireShortenUrl,
    renewShortenUrl,
    showRetry
  }), [targetUrl, shortenUrl, setShortenUrl, resetShortenUrl, expireShortenUrl, renewShortenUrl, showRetry]);
};
var useUrl$1 = useUrl;

export { useUrl$1 as default };
